import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesCB from "Dashboard/scenes/ConcreteBase/styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  selectConcreteBaseInputForUpdateItem,
  selectState,
  setUpdateInputItemPopover,
  updateConcreteBaseInput
} from "../inputSlice";
import { IConcreteBaseInputUpdate } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseInputUpdate";
import NumberInput from "Dashboard/components/NumberInput";

const UpdateConcreteBaseInputItemPopover = () => {
  const dispatch = useAppDispatch();
  const concreteBaseInput = useSelector(selectConcreteBaseInputForUpdateItem);
  const { updateInputItemPopover } = useSelector(selectState);
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useForm<IConcreteBaseInputUpdate>();

  const closeDialog = () => {
    dispatch(setUpdateInputItemPopover({ isOpen: false, itemRowIndex: -1 }));
    reset();
  };

  const onSubmit = async (data: IConcreteBaseInputUpdate) => {
    try {
      const cleanedData = {
        inputId: data.inputId,
        itemCode: data.itemCode !== concreteBaseInput.itemCode ? data.itemCode : undefined,
        itemName: data.itemName !== concreteBaseInput.item.name ? data.itemName : undefined,
        pricePerUnit: data.pricePerUnit !== concreteBaseInput.pricePerUnit ? data.pricePerUnit : undefined,
      }
      await dispatch(updateConcreteBaseInput(cleanedData));
      closeDialog();
      toast.success("Izmena je uspešno zabeležena.");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classes.basicPopoverView} 
        ${classes.gPopoverInputs}
        ${classesCB.updateInputItemPopover}
      `}
    >
      <p>Ovde menjate šifru, ime i cenu artikla na ulazu kao i na svim zapisima izlaza ovog artikla.</p>
      <input
        type="hidden"
        value={concreteBaseInput?.inputId}
        {...register("inputId")}
      />

      <div className={`${errors.itemCode ? classes.inputError : ""}`}>
        <div>
          <label>nova šifra</label>
          <input
            type="text" className={classes.solidBorder}
            autoFocus={updateInputItemPopover.focus === "itemCode"}
            defaultValue={concreteBaseInput !== null ? concreteBaseInput.itemCode : ""}
            {...register("itemCode", { required: false })} />
        </div>
      </div>
      <div className={`${errors.itemName ? classes.inputError : ""}`}>
        <div>
          <label>ime</label>
          <input
            type="text" className={classes.solidBorder}
            disabled
            defaultValue={concreteBaseInput !== null ? concreteBaseInput.item.name : ""} />
        </div>
      </div>
      <div>
        <div>
          <label>nova cena</label>
          <Controller
            control={control}
            name="pricePerUnit"
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <NumberInput
                  formatAs="rsd"
                  autoFocus={updateInputItemPopover.focus === "pricePerUnit"}
                  defaultValue={concreteBaseInput?.pricePerUnit !== null && concreteBaseInput?.pricePerUnit !== undefined ? concreteBaseInput.pricePerUnit.toString().replace(".", ",") : ""}
                  onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                  className={`${classes.solidBorder} ${errors.pricePerUnit ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.buttons}>
        <button type="submit" className={classes.iconButton}>
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  )
};

export default UpdateConcreteBaseInputItemPopover;
